module.exports = __webpack_public_path__ + "img/688.59c5896b.png";